module.exports = __webpack_public_path__ + "img/14.dc9a6b24.jpg";